import React from 'react'
import CONTENT from '@/constants/content'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import { IMediaCard } from '@pcln/contentful-components'
import useBootstrapData from '@/hooks/useBootstrapData'
import MediaCardComponent from '../MediaCard/MediaCardComponent'
import mediaCardContentsFallback from './content'

export default function VIP() {
  const {
    customer: { firstName }
  } = useBootstrapData()
  const promo = useContentfulVariation<IMediaCard>('leftPromoBox')
  const hasContentfulData = promo != null

  const headlineVIP = firstName
    ? CONTENT.homepage.vip.promo.headlineWithName.replace(
        '{firstName}',
        firstName
      )
    : CONTENT.homepage.vip.promo.headline

  mediaCardContentsFallback.heading = headlineVIP
  const mediaCardContent = hasContentfulData ? promo : mediaCardContentsFallback

  return <MediaCardComponent content={mediaCardContent} />
}
